/* Passepartout Detail — Fotorecord
   Gestisce le istanze di "passepartout-detail" (data-driven dal metaobject).
   Event detail (cartone): { tipo:'cartone', nome, imgUrl, larghezza,
                             spessoreMm, anima, colore, tinta, note } | null
   Event detail (legno):   { tipo:'legno', nome, imgUrl, larghezza, colore,
                             altezzaSezione, battenteMm,
                             fotoCampioneUrl, fotoAngoloUrl } | null */

var BADGE = { cartone: 'Passepartout cartone', legno: 'Passepartout legno' };
// Consiglio di fallback SOLO se il metaobject non porta una nota (il cartone
// la porta via campo `note`; il legno oggi non l'ha → fallback).
var FALLBACK_TIP = {
  cartone: '',
  legno: 'Il passepartout in legno aggiunge un bordo tridimensionale caldo e curato. Il profilo si abbina cromaticamente alla cornice scelta.'
};

function cap(s) { s = (s || '').trim(); return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

function fmtColore(detail) {
  var c = cap(detail.colore), t = (detail.tinta || '').trim();
  if (c && t && t.toLowerCase() !== (detail.colore || '').toLowerCase()) return c + ' · ' + t;
  return c || cap(detail.tinta);
}

function fmtSpessore(detail) {
  var s = parseFloat(detail.spessoreMm);
  if (!s) return '';
  return (Number.isInteger(s) ? String(s) : String(s).replace('.', ',')) + ' mm';
}

function fmtLarghezza(detail) {
  if (detail.larghezza == null || detail.larghezza === '') return '';
  return String(detail.larghezza).replace('.', ',') + ' cm';
}

function setRow(root, sel, value) {
  var dd = root.querySelector(sel);
  if (!dd) return;
  var row = dd.closest('.mdet-spec-row');
  if (value) { dd.textContent = value; if (row) row.style.display = ''; }
  else { dd.textContent = ''; if (row) row.style.display = 'none'; }
}

/* Mostra/nasconde una figure foto insieme alla sua immagine (stesso pattern di
   opera-cornice-detail.js::setFoto, ma su elementi passati per riferimento invece
   che per id: questa sezione monta più istanze sulla stessa pagina — cartone e
   legno — quindi non può usare id fissi). */
function setFoto(fig, img, url, alt) {
  if (!fig || !img) return;
  if (url) {
    img.src = url;
    img.alt = alt || '';
    fig.style.display = '';
  } else {
    img.removeAttribute('src');
    img.alt = '';
    fig.style.display = 'none';
  }
}

/* Disegna sezione trasversale del profilo come SVG inline. Nessun profilo legno ha
   una foto di sezione reale (il vocabolario sezioni_cornici è per-prodotto e il
   passepartout in legno non è un prodotto Shopify), quindi è sempre questo il
   disegno mostrato — stessa resa di opera-cornice-detail.js::buildCrossSection,
   copiata qui perché le due sezioni non condividono un asset JS comune. */
function buildCrossSection(larghezzaMm, altezzaSezione, battenteMm) {
  if (!larghezzaMm) return null;

  var vW = 240, vH = 160;
  var rx = 50, ry = 15;
  var rw = 90;

  var rh = 72;
  if (altezzaSezione && larghezzaMm) {
    rh = Math.round((altezzaSezione / larghezzaMm) * rw);
    rh = Math.max(30, Math.min(rh, 110));
  }

  var batH = 0;
  if (battenteMm > 0 && altezzaSezione > 0) {
    batH = Math.round((battenteMm / altezzaSezione) * rh);
    batH = Math.max(8, Math.min(batH, rh - 12));
  }

  var stroke  = 'rgba(0,0,0,.45)';
  var fill    = 'rgba(0,0,0,.08)';
  var fillBat = 'rgba(0,0,0,.18)';
  var dimClr  = 'rgba(0,0,0,.5)';
  var txtClr  = 'rgba(0,0,0,.65)';
  var font    = 'font-family="system-ui,sans-serif" font-size="9"';

  var s = '<svg viewBox="0 0 ' + vW + ' ' + vH + '" xmlns="http://www.w3.org/2000/svg" aria-label="Sezione trasversale profilo">';

  s += '<rect x="' + rx + '" y="' + ry + '" width="' + rw + '" height="' + rh + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="1.5"/>';

  if (batH > 0) {
    s += '<rect x="' + rx + '" y="' + ry + '" width="' + rw + '" height="' + batH + '" fill="' + fillBat + '" stroke="' + stroke + '" stroke-width="1.5"/>';
  }

  var dimY = ry + rh + 10;
  s += '<line x1="' + rx + '" y1="' + dimY + '" x2="' + (rx + rw) + '" y2="' + dimY + '" stroke="' + dimClr + '" stroke-width="1"/>';
  s += '<line x1="' + rx + '" y1="' + (dimY - 4) + '" x2="' + rx + '" y2="' + (dimY + 4) + '" stroke="' + dimClr + '" stroke-width="1"/>';
  s += '<line x1="' + (rx + rw) + '" y1="' + (dimY - 4) + '" x2="' + (rx + rw) + '" y2="' + (dimY + 4) + '" stroke="' + dimClr + '" stroke-width="1"/>';
  s += '<text x="' + (rx + rw / 2) + '" y="' + (dimY + 12) + '" text-anchor="middle" fill="' + txtClr + '" ' + font + '>' + larghezzaMm + ' mm</text>';

  if (altezzaSezione > 0) {
    var dLx = rx - 14;
    var midY = ry + rh / 2;
    s += '<line x1="' + dLx + '" y1="' + ry + '" x2="' + dLx + '" y2="' + (ry + rh) + '" stroke="' + dimClr + '" stroke-width="1"/>';
    s += '<line x1="' + (dLx - 4) + '" y1="' + ry + '" x2="' + (dLx + 4) + '" y2="' + ry + '" stroke="' + dimClr + '" stroke-width="1"/>';
    s += '<line x1="' + (dLx - 4) + '" y1="' + (ry + rh) + '" x2="' + (dLx + 4) + '" y2="' + (ry + rh) + '" stroke="' + dimClr + '" stroke-width="1"/>';
    s += '<text x="' + (dLx - 8) + '" y="' + midY + '" text-anchor="middle" fill="' + txtClr + '" transform="rotate(-90 ' + (dLx - 8) + ' ' + midY + ')" ' + font + '>' + altezzaSezione + ' mm</text>';
  }

  if (batH > 0 && battenteMm > 0) {
    var dRx = rx + rw + 12;
    s += '<line x1="' + dRx + '" y1="' + ry + '" x2="' + dRx + '" y2="' + (ry + batH) + '" stroke="' + dimClr + '" stroke-width="1"/>';
    s += '<line x1="' + (dRx - 4) + '" y1="' + ry + '" x2="' + (dRx + 4) + '" y2="' + ry + '" stroke="' + dimClr + '" stroke-width="1"/>';
    s += '<line x1="' + (dRx - 4) + '" y1="' + (ry + batH) + '" x2="' + (dRx + 4) + '" y2="' + (ry + batH) + '" stroke="' + dimClr + '" stroke-width="1"/>';
    var lblX = dRx + 8;
    var lblY = ry + batH / 2 + 3;
    s += '<text x="' + lblX + '" y="' + lblY + '" fill="' + txtClr + '" ' + font + '>' + battenteMm + ' mm</text>';
    s += '<text x="' + lblX + '" y="' + (lblY + 11) + '" fill="' + dimClr + '" font-size="7" font-family="system-ui,sans-serif" opacity=".7">battente</text>';
  }

  s += '</svg>';
  return s;
}

function populateSection(root, detail) {
  var ph  = root.querySelector('.mdet-placeholder');
  var det = root.querySelector('.mdet-detail');
  if (!ph || !det) return;

  if (!detail || !detail.nome) {
    ph.style.display  = '';
    det.style.display = 'none';
    return;
  }

  ph.style.display  = 'none';
  det.style.display = '';

  var tipo  = detail.tipo || 'cartone';
  var badge = root.querySelector('.mdet-badge');
  if (badge) { badge.textContent = BADGE[tipo] || BADGE.cartone; badge.className = 'mdet-badge'; }

  /* Nome + codice pubblico nel nome (mirror di codice_prodotto.nome_cliente, 15/09/2026):
     la riga «Codice prodotto» non c'e' piu'. */
  var core = window.FOTORECORD && window.FOTORECORD.core;
  var nome = root.querySelector('.mdet-nome');
  if (nome) nome.textContent = (core && core.nomeCliente) ? core.nomeCliente(detail.nomeBreve || detail.nome, detail.sku) : (detail.nome || '');

  // Righe data-driven — auto-nascoste se il dato è vuoto (il legno non ha colore/spessore/anima)
  setRow(root, '.pdet-val-colore',    fmtColore(detail));
  setRow(root, '.pdet-val-spessore',  fmtSpessore(detail));
  setRow(root, '.pdet-val-anima',     (detail.anima || '').trim());
  setRow(root, '.pdet-val-larghezza', fmtLarghezza(detail));

  var dtLargh = root.querySelector('.pdet-dt-larghezza');
  if (dtLargh) dtLargh.textContent = tipo === 'legno' ? 'Larghezza profilo' : 'Larghezza bordo';

  var tip = root.querySelector('.mdet-tip');
  if (tip) tip.textContent = (detail.note && detail.note.trim()) || FALLBACK_TIP[tipo] || '';

  var img  = root.querySelector('.mdet-media__img');
  var icon = root.querySelector('.mdet-media__icon');
  if (img && icon) {
    // Convenzione 02/08/2026: il legno è una seconda cornice → thumb = quarto in
    // alto a destra del master (classe in material-detail.css); il cartone è uno
    // swatch piatto e resta intero.
    img.classList.toggle('mdet-media__img--quadrante', tipo === 'legno');
    if (detail.imgUrl) {
      img.src = detail.imgUrl; img.alt = detail.nome || ''; img.style.display = ''; icon.style.display = 'none';
    } else {
      img.style.display = 'none'; icon.style.display = '';
    }
  }

  // Sezione del profilo + Foto reali: solo per il legno. Il cartone è uno swatch
  // piatto (nessuna sezione, nessuna foto barra/angolo) — blocchi sempre nascosti.
  var blkSezione = root.querySelector('.pdet-block-sezione');
  var blkFoto     = root.querySelector('.pdet-block-foto');

  if (tipo === 'legno') {
    var diag = root.querySelector('.pdet-section-diagram');
    var larghezzaMm = (detail.larghezza || 0) * 10; // detail.larghezza è già in cm
    var svgMarkup = diag ? buildCrossSection(larghezzaMm, detail.altezzaSezione, detail.battenteMm) : null;
    if (diag && svgMarkup) {
      diag.innerHTML = svgMarkup;
      if (blkSezione) blkSezione.style.display = '';
    } else if (blkSezione) {
      blkSezione.style.display = 'none';
    }

    var figCampione = root.querySelector('[data-pdet-foto="campione"]');
    var figAngolo   = root.querySelector('[data-pdet-foto="angolo"]');
    var fotoCampione = detail.fotoCampioneUrl || '';
    var fotoAngolo   = detail.fotoAngoloUrl   || '';
    setFoto(figCampione, figCampione && figCampione.querySelector('img'), fotoCampione,
            'Passepartout ' + (detail.nome || '') + ' — foto del profilo');
    setFoto(figAngolo, figAngolo && figAngolo.querySelector('img'), fotoAngolo,
            'Passepartout ' + (detail.nome || '') + ' — campione d’angolo');
    if (blkFoto) blkFoto.style.display = (fotoCampione || fotoAngolo) ? '' : 'none';
  } else {
    if (blkSezione) blkSezione.style.display = 'none';
    if (blkFoto)     blkFoto.style.display = 'none';
  }
}

/* Stesso problema di detail-accordion.js e material-detail.js, risolto allo stesso modo:
   incluso via <script type="module">, il browser valuta questo file una sola volta per
   pagina anche con più tag che puntano allo stesso URL (i template che montano sia il
   passepartout in cartone sia quello in legno — aste singolo, aste multiplo, opere
   d'autore — emettono due tag). Il marcatore sul dataset resta come difesa aggiuntiva
   per il caso di un root rimontato dinamicamente nel DOM. */
document.querySelectorAll('[data-pdet-event]').forEach(function (root) {
  if (root.dataset.pdetBound) return;
  root.dataset.pdetBound = '1';

  var eventName = root.dataset.pdetEvent;
  var initKey   = root.dataset.pdetInit;

  document.addEventListener(eventName, function (e) {
    populateSection(root, e.detail);
  });

  setTimeout(function () {
    if (initKey && window[initKey]) populateSection(root, window[initKey]);
  }, 0);
});
